import type { LunyaCardSize } from './types'

/** Диаметр мини-Луни по умолчанию (UI-кит §12 «Карточка-реплика Луни»). */
export const LUNYA_CARD_AVATAR_SIZE_DEFAULT = 38

/** Размер текста по размеру карточки: маленькая карточка — и текст на ступень мельче. */
export const LUNYA_CARD_TEXT_VARIANT: Record<LunyaCardSize, 'BODY' | 'BODY_S'> = {
  S: 'BODY_S',
  M: 'BODY',
  L: 'BODY',
}

/** Крестик мельче обычного: карточка совета сама по себе маленькая. */
export const LUNYA_CARD_CLOSE_ICON_SIZE = 16

/**
 * Коробка кнопки — размером с глиф (`XS` = 24px), а не 44×44.
 *
 * У коробки 44×44 глиф сидит в её центре, поэтому в карточке высотой в одну-две строки
 * крестик вставал по середине текста и наезжал на него (правка основателя по совету на
 * полотне уз). Зону нажатия 44×44 кнопка добирает псевдоэлементом наружу — на раскладку
 * карточки та не влияет.
 */
export const LUNYA_CARD_CLOSE_SIZE = 'XS' as const

export const LUNYA_CARD_CLOSE_LABEL = 'Закрыть совет'
